import { css } from '@emotion/react'
import { breakpoint, size, width } from '@twistopayments/design-system/styles'

export const content = css`
  height: 100%;
`

export const hero = css`
  position: relative;
  overflow: visible;
  z-index: 1;
  border-radius: 0 ${size[80]} 0 0;
  padding: 0;
  padding-top: ${size[56]};
  height: 100%;

  ${breakpoint.up('md')} {
    max-height: 60rem;
  }

  ${breakpoint.up('sm')} {
    background: 0 0;
  }
`

export const heroCell = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const cellContent = css`
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;
  max-width: ${width.container.large};
  width: 100%;
  padding: 0 ${size[20]};
  text-align: center;

  ${breakpoint.up('smMd')} {
    padding: ${size[20]};
  }

  ${breakpoint.up(88)} {
    padding: 0;
  }
`

export const figure = css`
  margin: ${size[18]} auto 0;
  display: flex;
  justify-content: center;

  & > div {
    width: auto;
    max-width: none;
  }

  img {
    width: auto;
    max-width: none;
    height: auto;
  }
`

export const cta = css`
  display: flex;
  flex-direction: column;
  row-gap: ${size[12]};

  margin-top: ${size[8]};

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    column-gap: ${size[24]};
  }
`

export const button = css`
  height: ${size[60]};
  padding: 0 ${size[48]};
`
